module.exports = __webpack_public_path__ + "img/icon1.0999cd26.png";